// extracted by mini-css-extract-plugin
export default {"shareWrapper":"shareButtons_shareWrapper__otjYc","buttonShare":"shareButtons_buttonShare__DuaOJ"};